var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8961 11.3023L11.466 7.68118H7.95527V5.32748C7.95527 4.33734 8.4454 3.36984 10.0127 3.36984H11.6313V0.28626C10.6887 0.135952 9.73625 0.0546359 8.78166 0.0429688C5.89215 0.0429687 4.0057 1.77996 4.0057 4.92011V7.68118H0.802734V11.3023H4.0057V20.0607H7.95527V11.3023H10.8961Z",
    fill: "#252153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbActive);
export default __webpack_public_path__ + "static/media/fb-active.a46a55cd545d0438522bbdd2220cea11.svg";
export { ForwardRef as ReactComponent };